import styled from 'styled-components'

import { Card } from '@/components/ui/card'
import { media } from '@/theme/common'

export const Container = styled(Card)(({ theme }) => ({
  // Note: Card's own `overflow: hidden` makes flex's default `min-height: auto` behave like
  // `min-height: 0` (per spec) - without this, this Card would silently shrink to whatever
  // height its flex parent (Page) allots it whenever the table below it also wants room,
  // clipping the report cards instead of showing them all (see ContentCard's identical note
  // in client-profile/general-information.styled.ts for the same pattern).
  boxShadow: 'none',
  flexShrink: 0,
  gap: theme.space['16'],
  // Note: Card's own base styles set `height: 100%` unconditionally - resolves against
  // whatever height its flex parent (Page) ends up with, which is itself derived (in part)
  // from *this* element's own rendered height, so the two feed each other and can spiral to
  // an absurd size (observed: 2574px for a card that only needs ~160px). Overridden to `auto`
  // so this Card sizes to its own content instead (see table-group.styled.ts's Card for the
  // identical fix applied to the same root cause).
  height: 'auto',
}))

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space['16']};
`

// Note: matches table-group.styled.ts's NavigationDatePicker - a fixed, comfortable width
// instead of stretching to fill the header row's leftover space.
export const DateRangeWrapper = styled.div`
  flex-shrink: 0;
  width: 22.5rem;
  max-width: 100%;
`

export const CardsGrid = styled.div(
  ({ theme }) => `
  display: grid;
  gap: ${theme.space['16']};
  grid-template-columns: repeat(2, 1fr);

  ${media.up('sm')} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${media.up('lg')} {
    grid-template-columns: repeat(7, 1fr);
  }
`,
)

export const ReportCard = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.space['4']};
  padding: ${theme.space['16']};
  border: ${theme.border.size['1']} solid ${theme.colors.gray400};
  border-radius: ${theme.border.radius['8']};
`,
)
